/* eslint-disable no-unused-vars */
import { Box, Card } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BaseRegistration } from '../../../core/baseRegistration';
import { useState } from 'react';
import { OTPTypes } from '../../../../../constants/otpTypes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { buildLocalizeRoute } from '../../../../../helpers/languageHelper';
import { AppRoutes } from '../../../../../constants/appRoutes';
import { Logout, loginUsingToken } from '../../../../../services/authService';
import { Toaster } from '../../../../../shared/components/common/toaster';
import { UserService } from '../../../../../services/userService';
import { useEffect } from 'react';
import { OTPAuthenticationDialog } from '../../../../../shared/components/otpAuthenticationDialog';
import { EligibilityChecker } from '../eligibilityChecker';
import { LocalStorageKey } from '../../../../../constants/localStorageKeys';
import { IS_SA } from '../../../../../config/appConfig';
import { Platform } from '../../../components/platform';
import { LanguageService } from '../../../../../services/languageService';
import { SignupPageWrapper } from '../../../core/signUpPageWrapper';

export const BorrowerBaseRegistration = ({
	regCountryList = [],
	isSA = IS_SA,
}) => {
	const userService = new UserService();
	const languageService = new LanguageService();
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [showOTPAuth, setShowOTPAuth] = useState(false);

	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [email, setEmail] = useState(null);
	const [showEligibility, setShowEligibility] = useState(
		// Skip eligibility checker for KSA, only show for Global
		!isSA && sessionStorage.getItem(LocalStorageKey.isEligibilityCompleted) !== '1'
	);

	useEffect(() => {
		setEmail(searchParams.get('email'));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchParams.get('email')]);

	const onNavigateToNextScreen = () => {
		let route = IS_SA
			? AppRoutes.IRegNafathVerification
			: AppRoutes.BRegPersonalInfo;
		navigate(buildLocalizeRoute(`${AppRoutes.BorrowerRegistartion}/${route}`));
	};

	const isAr = () => languageService.isArabic();

	const onSubmit = (values) => {
		if (!values.termsConditionsForInvestmentsAccepted || !values?.shariahTandCAccepted) {
			Toaster({ msg: t('termsAndConditionsRequired') });
			return;
		}

		setLoading(true);
		userService
			.registerBorrower(values)
			.then((resp) => {
				sessionStorage.setItem(LocalStorageKey.isEligibilityCompleted, '0');
				let tokenModel = resp.data;
				if (tokenModel) {
					setLoading(false);
					if (!resp.data?.emailConfirmed) {
						navigate(buildLocalizeRoute(`${AppRoutes.VerifyEmail}?e=${encodeURIComponent(values.email)}&type=2`));
					} else {
						loginUsingToken(tokenModel.token);
						if (tokenModel.otpRequested) {
							setShowOTPAuth(true);
						} else {
							onNavigateToNextScreen();
						}
					}

				}
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	return (
		<Box className="justify-center items-center flex">
			{!showEligibility ? (
				<SignupPageWrapper user='borrower'>
					<BaseRegistration
						defaultEmail={email}
						loading={loading}
						clientType={'borrower'}
						onSubmitForm={(values) => {
							onSubmit(values);
						}}></BaseRegistration>
				</SignupPageWrapper>

			) : (
				<EligibilityChecker
					isSA={isSA}
					regCountryList={regCountryList}
					onSubmit={() => {
						window.location.reload();
					}}
				/>
			)}

			{showOTPAuth ? (
				<OTPAuthenticationDialog
					type={OTPTypes.Authentication}
					onClose={(isVerified) => {
						setShowOTPAuth(false);
						if (isVerified) {
							onNavigateToNextScreen();
						} else {
							Logout();
							navigate(buildLocalizeRoute(AppRoutes.Login));
						}
					}}
					state={showOTPAuth}></OTPAuthenticationDialog>
			) : null}
		</Box>
	);
};
